<template>
  <b-container>
    
    <b-modal :id="id" :centered="centered" header-bg-variant="primary" header-text-variant="light" 
    :size="size" :title="title" @ok="saveProduct" @hidden="resetModal" @show="loadModal">
      <b-row>
        <b-col sm="12">
          <BAlert class="mt-2" :show="messageShow" :variant="messageVariant" dismissible>
            <span>{{ messageText }}</span>
          </BAlert>
        
        <form ref="form" @submit.stop.prevent="handleSubmit" class="mx-auto" validated>  
          <BRow>
            <BCol class="text-center">
               <ProductThumbnail
                  :product-id="product.id"
                  :product-name="product.productName"
                  :current-image-url="product.imageUrl"
                  @image-updated="onImageUpdated"
                  @show-message="showMessage"
                  @save-product-first="handleSaveProductFirst"
                />
            </BCol>
          </BRow>
          <b-form-group label-cols-sm="2" class="m-1" label-size="sm"
              content-cols-sm="10"
              id="productName"
              label="Nome Do Produto:"
              label-for="productNameInput"
              label-class="font-weight-bold"
              :state="nameState" invalid-feedback="Nome do Produto é Obrigatório" >
  
              <b-form-input
                      id="productNameInput"
                      v-model="product.productName"
                      type="text"
                      placeholder="Nome do Novo Produto"
                      required
                ></b-form-input>

          </b-form-group>
          

          <b-form-group label-cols-sm="2" class="m-1" label-size="sm"
              content-cols-sm="10"
              id="productMaterialCost"
              label="Custo do Material:"
              label-for="productMaterialCostInput" 
              label-class="font-weight-bold"
              >             
              
              <BInputGroup prepend="R$">
                <b-form-input
                        id="productMaterialCostInput"
                        v-model="materialCost"
                        type="text"
                        placeholder="Custo dos Materiais"
                        v-currency
                        disabled
                  ></b-form-input>
              </BInputGroup>
              

          </b-form-group>
          
          <b-form-group label-cols-sm="2" class="m-1" label-size="sm"
              content-cols-sm="10"
              id="productProfit"
              label="Lucro Do Produto:"
              label-for="productProfitInput"
              label-class="font-weight-bold"
              >
          
              <BInputGroup prepend="%">
                
                <b-form-input
                        id="productProfitInput"
                        :value="formattedProfit"
                        type="text"
                        @input="handleInput"
                        placeholder="Lucro Do Produto"
                        :disabled="buttonProfitDisable"

                  ></b-form-input>
                  <BInputGroupAppend v-if="deleteButton">
                    <BButton variant="info">
                      <BIcon style="width: 0.9rem;" icon="pencil-fill" @click="editButton"/>
                    </BButton>
                  </BInputGroupAppend>
                </BInputGroup>
            
          </b-form-group>

          <BRow class="mt-4 justify-content-center">
            <BCol xs="12" sm="10" md="8" lg="10">
              <div class="production-time-container">
                <h5 class="text-center mb-3">Tempo de Produção</h5>
                <BRow class="align-items-center">
                  <BCol xs="12" md="6" class="mb-3">
                    <BFormGroup
                      label="Horas:"
                      label-for="productWorkingHoursInput"
                      label-class="font-weight-bold mb-2"
                      class="time-input-group"
                    >
                      <BInputGroup>
                        <b-form-input
                          id="productWorkingHoursInput"
                          v-model="internalWorkingHours"
                          type="number"
                          min="0"
                          step="1"
                          placeholder="Horas"
                          :disabled="editWorkingHours"
                          class="text-center"
                        ></b-form-input>
                        <BButtonGroup size="sm">
                          <BButton variant="info" @click="editWorkingHours = !editWorkingHours">
                            <BIcon icon="pencil-fill" shift-v="-1"/>
                          </BButton>
                          <BInputGroupText class="border-left-0 rounded-end">Hrs</BInputGroupText>
                        </BButtonGroup>
                      </BInputGroup>
                    </BFormGroup>
                  </BCol>

                  <BCol xs="12" md="6" class="mb-3">
                    <BFormGroup
                      label="Minutos:"
                      label-for="productWorkingMinutesInput"
                      label-class="font-weight-bold mb-2"
                      class="time-input-group"
                    >
                      <BInputGroup>
                        <b-form-input
                          id="productWorkingMinutesInput"
                          v-model="internalWorkingMinutes"
                          @blur="validateWorkingMinutes"
                          type="number"
                          min="0"
                          max="59"
                          step="1"
                          placeholder="Minutos"
                          :disabled="editWorkingMinutes"
                          ref="minutesInput"
                          class="text-center"
                        ></b-form-input>
                        <BButtonGroup size="sm">
                          <BButton variant="info" @click="editWorkingMinutes = !editWorkingMinutes">
                            <BIcon icon="pencil-fill" shift-v="-1"/>
                          </BButton>
                          <BInputGroupText class="border-left-0 rounded-end">Min</BInputGroupText>
                        </BButtonGroup>
                      </BInputGroup>
                    </BFormGroup>
                  </BCol>
                </BRow>
              </div>
            </BCol>
          </BRow>

          <BRow class="mb-1">
            <BCol>
              <BFormGroup label-cols-sm="2" content-cols-sm="10" class="m-1" label-size="sm"
                label="Preço de Venda" label-for="productPriceInput" label-class="font-weight-bold">
                <BInputGroup prepend="R$">
                  <BFormInput id="productPriceInput" v-model="productPrice" disabled />
                </BInputGroup>
              </BFormGroup> 
            </BCol>

            <BCol>
              <BFormGroup label-cols-sm="2" content-cols-sm="10" class="m-1" label-size="sm"
                label="Lucro Estimado" label-for="productPriceInput" label-class="font-weight-bold">
                <BInputGroup prepend="R$">
                  <BFormInput id="productPriceInput" v-model="estimatatedProfit" disabled />
                </BInputGroup>
              </BFormGroup>     
            </BCol>
          
          </BRow>

        </form>
        </b-col>
      </b-row>
        <b-row class="my-2">
          <b-col sm="10" class="d-flex justify-content-between align-items-center">
            <h5>Custos dos Materiais</h5>
            <b-button-group>
              <b-button variant="primary" class="px-2" size="sm" v-b-modal.newItemCost>Adicionar Material</b-button>
            </b-button-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-table small id="tableProducts" striped 
            hover :items="product.directCosts" :fields="costFields"
            @row-clicked="onRowClicked">

               <template #cell(costByItem)="data">
                    <span class="fs-6">{{ parseFloat(data.value) ? parseFloat(data.value).toLocaleString('pt-BR', {
                      style: 'currency',  
                      currency: 'BRL',
                      minimumFractionDigits: 2, 
                      maximumFractionDigits: 2                  
                    }) : parseFloat(0).toLocaleString('pt-BR', {
                      style: 'currency',  
                      currency: 'BRL',
                      minimumFractionDigits: 2, 
                      maximumFractionDigits: 2                  
                    }) }}</span>
                </template>

              <template #cell(options)="row">
                      <option-buttons :rowItem="row.item" :rowIndex="row.index"
                        @viewItem="(item)=>viewCost(item)" 
                        @copyItem="(item)=>copyDirectCost(item)"
                        />
              </template>

            </b-table>
          </b-col>
        </b-row>
        
        <BRow>
            <BButtonGroup class="m-1 px-1">            
              <button v-if="deleteButton" class="btn btn-danger" @click="delProduct">Apagar</button>
            </BButtonGroup>
        </BRow>
        <BAlert class="mt-2" :show="messageShow" :variant="messageVariant" dismissible>
            <span>{{ messageText }}</span>
          </BAlert>
          <template #modal-ok>
              Salvar
          </template>
       
    </b-modal>

    <direct-cost-item id="newItemCost" 
      :item="costItem" 
      @newItem="e => addItem(e)"
      @deleteDirectCost="id=>deleteDirectCost(id)" />

  </b-container>
</template>

<script>
import OptionButtons from "../components/OptionButtons.vue"
import DirectCostItem from "../components/DirectCostItem.vue"
import { formatDecimalPtBR } from "@/helpers";
import { productionHoursTohoursMinutes } from "@/helpers";
import ProductThumbnail from "@/components/ProductThumbnail.vue";
import axios, { AxiosError } from "axios";
import logout from "@/helpers/LogoutHelper";
import store from "@/store";
import Vue from 'vue'


export default {
    props:{
        id:{
            type:String,
            required: true,
            default(){
              return "modalID"
            }
        },  
        title:{
            type: String,
            default(){
              return "Produto Novo"
            } 
        },
        size:{
          type:String,
          default(){
            return "xl"
          }
        },
        centered:{
          type: Boolean,
          default(){
            return true
          }
        },
        variableCosts:{
          type: Number,
          required:true
        },
        fixedCosts:{
          type:Number,
          required:true
        },
        profit:{
          type:Number,
          required:true
        },
        productOne: {
          type: Object,
          required:true,
        },
    },
    data(){
      return {
        product:{
          ...this.productOne
        },
        costFields:[
          {key:"costName", label:"Nome do Material", sortable:true},
          // {key:"price", label:"Valor", sortable:true, type:Number},
          // {key:"quantity", label:"Qtd"},
          {key:"costByItem", label:"Custo do Material", type:Number},
          {key:'options', label:"Ações"},
        ],
        nameState: null,
        savedValue: null,
        profitDisable: true,
        costItem: null,
        messageShow: null,
        messageText: null,
        messageVariant:null,    
        internalWorkingHours: 0,
        internalWorkingMinutes: 0,
        editWorkingHours: true,
        editWorkingMinutes: true,
      }
    },
  computed: {
      materialCost(){
        const total = this.product.directCosts.length > 0 ? this.product.directCosts.map( item => parseFloat(item.costByItem)).reduce((acc,item)=>acc+parseFloat(item)) : 0
        return formatDecimalPtBR(total)
      },
      formattedProfit(){
          const profit = this.product.profit || this.profit; // Se for null ou undefined, considera 0
          
          return `${(profit * 100).toFixed(0)}`;
        },
      deleteButton(){
        return this.product.id ? true : false
      },
      buttonProfitDisable() {
        if (!this.product.id) {
          return false;
          }
          return this.profitDisable
      },
      previewProductionHours() {
          const hours = parseFloat(this.internalWorkingHours) || 0;
          const minutes = parseFloat(this.internalWorkingMinutes) || 0;
          
          if (hours > 0 || minutes > 0) {
              return (hours * 60) + minutes;
          }
          
          return this.product.productionHours || 0;
      },
      productPrice() {                                
          const hourCost = (parseFloat(this.fixedCosts) +  parseFloat(this.variableCosts)) * parseFloat(this.previewProductionHours/60)
          const materialCost = parseFloat(this.materialCost.replace(',','.')) ? parseFloat(this.materialCost.replace(',','.')) : 0
          
          const price = ((hourCost + materialCost) * (1+parseFloat(this.product.profit))) 
          
          // return price > -1 ? formatDecimalPtBR(parseFloat(price)) : 0
          return price > -1 ? formatDecimalPtBR(parseFloat(price)) : "0" 
        },
      estimatatedProfit() {          
          const profit = parseFloat(this.productPrice.replace(".","").replace(",",".") - (parseFloat(this.fixedCosts) + parseFloat(this.variableCosts)+ parseFloat(this.materialCost))).toFixed(2)        
        return profit > -1 ? formatDecimalPtBR(parseFloat(profit)) : 0 
      },           
  },
  watch: {
      productOne: {
        handler(newValue) {
            Vue.set(this, 'product', newValue);
            const { hours, minutes } = productionHoursTohoursMinutes(this.product.productionHours || 0);
            this.internalWorkingHours = hours;
            this.internalWorkingMinutes = minutes;            
        },
        deep: true,
        immediate: true
      }
    },
    methods:{
      loadModal(){                    
          const {hours, minutes} = productionHoursTohoursMinutes(this.productOne.productionHours);          
          this.internalWorkingMinutes = minutes;
          this.internalWorkingHours = hours;          
      },  
      validateWorkingMinutes(){        
        if (this.internalWorkingMinutes > 59){
          const msgHTML = "O total de minutos máximo permitido neste campo é 59 minutos."
          this.$bvModal.msgBoxOk(msgHTML,{
            title:"Atenção",
            size:"sm",
            buttonSize: 'sm',
            centered:true,
            okVariant:"info",
            headerBgVariant:"warning",
            headerTextVariant:"white"
          }).then(() => {
                const { minutes } = productionHoursTohoursMinutes(this.product.productionHours);
                this.internalWorkingMinutes = minutes;
                this.editWorkingMinutes =false;
          })
        }
      },
      async addItem(newItem) {

        if (this.product && !this.product.id) {
          await this.handleSubmit(true)
        }
        
        try {
          const result = await axios.post(`${process.env.VUE_APP_ROOT_API}/products/directcosts`, {
            id: newItem.id,
            costName: newItem.costName,
            price: newItem.price,
            quantity: newItem.quantity,
            costByItem: newItem.costByItem,
            productId: this.product.id
          },
            {
              headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
              }
            });

          if (result.status === 201) {
            const index = this.product.directCosts.findIndex(cost => cost.costName == newItem.costName)
            
            if (index >  -1) {
              // Atualizar item existente
              Vue.set(this.product.directCosts, index, newItem);

              this.messageShow = 3
              this.messageText = `Custo Direto ${newItem.costName} Atualizado`
              this.messageVariant = `success`

            } else {

              this.messageShow = 3
              this.messageText = `Custo Direto Adicionado`
              this.messageVariant = `success`

              this.product.directCosts.push(newItem)
            }
          }

          // Emitir o evento 'cost-updated' com o ID do produto e o novo custo total
            this.$emit('cost-updated', { productId: this.product.id, materialCost: parseFloat(this.materialCost.replace(',', '.')) });

        } catch (error) {
          if (error instanceof AxiosError) {
                    const { response } = error
                    console.error(response)
                    if (response.status === 401) {
                        logout()
                    }
                    console.error(error)
                }
        }
      },
      saveProduct(bvModalEvent){
            bvModalEvent.preventDefault()
            // Trigger submit handler
            this.handleSubmit()
      },
      async handleSubmit(directcost) {
        // Exit when the form isn't valid
        const flag = !directcost ? false : true
        
         if (!this.checkFormValidity()) {
           return
         }
        // Push the name to submitted names
        let item = null      
        this.product.productionHours = (parseFloat(this.internalWorkingHours?this.internalWorkingHours:0) * 60) + parseFloat(this.internalWorkingMinutes?this.internalWorkingMinutes:0);
        this.product.productionHours <=0 ? this.product.productionHours=60 : this.product.productionHours 
        try {
          //chech if product.profit is undefined and set formattedProfit/100 ou this.profit
          !this.product.profit ? this.product.profit = parseFloat(this.formattedProfit) / 100 : this.profit
          const { data } = await axios.post(`${process.env.VUE_APP_ROOT_API}/products`, {
            id: this.product.id || -1,
            name: this.titleCase(this.product.productName),
            profit: parseFloat(this.product.profit),
            productionHours: this.product.productionHours,
            materialCost: parseFloat(this.materialCost),
            directCosts: this.product.directCosts.map(({ price, costByItem, costName, quantity }) => ({
              costName,
              price: parseFloat(parseFloat(price).toFixed(2)),
              costByItem: parseFloat(parseFloat(costByItem).toFixed(2)),
              quantity: parseFloat(quantity)
            }))
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          })

          if (data.id) {
            item = data
            this.product.id = data.id
          }

          this.$bvToast.toast(`Produto ${data.name} Salvo!`, {                    
                    autoHideDelay: 5000, 
                    appendToast: true, 
                    toaster: 'b-toaster-bottom-right',
                    variant: 'success',
                    solid: true
          });
          console.log(`Produto "${data.name}" Salvo Com Sucesso`)
          

        } catch (error) {
          if (error instanceof AxiosError) {
                    const { response } = error                   

                    if (response && response.status === 400) {
                        const msgHTML = "Nome do Produto já existe. Por favor, escolha outro nome."
                        this.$bvModal.msgBoxOk(msgHTML,{
                          title:"Atenção",
                          size:"sm",
                          buttonSize: 'sm',
                          centered:true,
                          okVariant:"info",
                          headerBgVariant:"warning",
                          headerTextVariant:"white"
                        });
                    } 

                    if (response.status === 401) {
                        logout()
                    }
                    console.error(error)
          }
        }
         
                
        this.$emit("newProduct", {
          id: item ? item.id : -1,
          productName: this.titleCase(this.product.productName),
          materialCost: this.materialCost,
          finalPrice: parseFloat(this.productPrice.replace('.','').replace(',','.')),
          profit: parseFloat(this.product.profit)
        })

        if (flag === false) {
            // Hide the modal manually
            this.$nextTick(() => {
              this.$bvModal.hide(this.id)
            })
        }

        

      },
      resetModal() {        
        this.nameState = null
        this.messageShow = null
        this.internalWorkingHours = 0
        this.internalWorkingMinutes = 0
        this.editWorkingHours = true
        this.editWorkingMinutes = true
        this.profitDisable = true
      },
      checkFormValidity() {
        const valid = this.$refs.form.checkValidity()
        this.nameState = valid
        return valid
      },
      async delProduct() {            
        //confirm
        const h = this.$createElement
        
        const msgHTML = h('div', {class:["text-center"],domProps:{innerHTML:`
                  <p>Tem Certeza que Deseja Apagar? <br/>
                  <br/> <small class="text-danger fw-bold fs-2">Essa Operação Não Pode Ser Desfeita!</small></p>`}})

        this.$bvModal.msgBoxConfirm(msgHTML,{
                title:"Apagar Produto",
                size:"md",
                centered:true,
                okVariant:"danger",
                okTitle:"Apagar",
                cancelTitle:"Cancelar",
                headerBgVariant:"primary",
                headerTextVariant:"white"

        })
        .then( async confirm =>{
          if (confirm) {
              try {
                const result = await axios.delete(`${process.env.VUE_APP_ROOT_API}/products?id=${this.product.id}`, {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem('token')}`
                    }
                });

                                        
                if (result.status === 200) {
                  console.log(result.data.message)
                  this.$emit("delItem", this.product.id )
                  this.$bvModal.hide(this.id)
                }

              } catch (error) {
                    if (error instanceof AxiosError) {
                      const {response} = error
                      console.error(response)
                      if (response.status === 401) {
                          logout()
                      }
                    }
                      console.error(error)
                }      
          }
        })
      }, //close deleteProduct
      editButton() {
        this.profitDisable = !this.profitDisable
      },
      handleInput(value) {
        const inputValue = value;
        if (inputValue > 0){
          const parsedValue = parseFloat(inputValue) / 100;
          
          this.product.profit = isNaN(parsedValue) ? 0 : parsedValue;
        }

        if (inputValue < 0) {
          this.product.profit = 0
        }
      },
      onRowClicked(item,index) {
        this.viewCost({index,target:item})
      },
      viewCost(item) {
        this.costItem = item
        this.$bvModal.show('newItemCost')
      },
      async deleteDirectCost(id){
        try {
          const { data, status } = await axios.delete(`${process.env.VUE_APP_ROOT_API}/products/directcost?product=${this.product.id}&directcost=${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          })

          if (status === 200) {

            if (data.directcost >= 0 && data.product >= 0) {
                const index = this.product.directCosts.findIndex(cost=>cost.id==data.directcost)
              this.product.directCosts.splice(index,1)
              this.messageShow = 3
              this.messageText = `Custo Direto Apagado`
              this.messageVariant = `success`
            } else {
               this.messageShow = 3
              this.messageText = `Não foi possível apagar`
              this.messageVariant = `warning`
            }

            
          }

          // Emitir o evento 'cost-updated' com o ID do produto e o novo custo total
          this.$emit('cost-updated', { productId: this.product.id, materialCost: parseFloat(this.materialCost.replace(',', '.')) });
          
        } catch (error) {
          if (error instanceof AxiosError) {
              const {response} = error
              console.error(response)
              
              if (response.status === 401) {
                 logout()
              }

              this.messageShow = 3
              this.messageText = `Server Error. Entre em contato com o administrador`
              this.messageVariant = `danger`

          }
          
        }
      },
      copyDirectCost(data) {
        data.target.costName = data.target.costName + ' Cópia'
        delete data.target.id
        this.costItem = data
        this.$bvModal.show('newItemCost')
      },
      onImageUpdated(imageUrl) {
      this.product.imageUrl = imageUrl;
      this.messageShow = 3;
      this.messageText = 'Imagem do produto atualizada com sucesso!';
      this.messageVariant = 'success';
      },
      
      showMessage(messageData) {
        
        this.messageShow = messageData.timeout || 5; // Default timeout is 3 seconds
        this.messageText = messageData.text;
        this.messageVariant = messageData.variant;

      },
      async handleSaveProductFirst({ callback }) {
        try {
          // Validar se tem nome do produto
          if (!this.checkFormValidity()) {
            this.showMessage({
              text: 'Por favor, preencha o nome do produto antes de adicionar uma imagem',
              variant: 'warning',
              timeout: 5
            });
            return;
          }

          // Salvar o produto primeiro
          await this.handleSubmit(true);

          // Se o produto foi salvo com sucesso (tem ID), chamar o callback
          if (this.product.id) {
            callback(this.product.id);
          }
        } catch (error) {
          this.showMessage({
            text: 'Erro ao salvar o produto. Tente novamente.',
            variant: 'danger',
            timeout: 5
          });
          console.error('Erro ao salvar produto:', error);
        }
      },
      titleCase(str) {
          if (!str) {
            return ""; // Retorna string vazia se a entrada for nula ou vazia
          }
          // Converte toda a string para minúsculas primeiro para tratar casos como "vestIDO preTO"
          const lowerCaseString = str.toLowerCase();
          // Divide a string em palavras
          const words = lowerCaseString.split(' ');

          // Mapeia cada palavra para sua versão com a primeira letra maiúscula
          const titleCasedWords = words.map(word => {
            if (word.length === 0) {
              return ""; // Retorna string vazia se a palavra for vazia (ex: múltiplos espaços)
            }
            return word.charAt(0).toUpperCase() + word.slice(1);
          });

          // Junta as palavras novamente em uma string
          return titleCasedWords.join(' ');
      }
  },
  created() {   
    this.product.profit = this.profit
  },
  beforeUpdate() {
     store.commit("setProductName", this.product.productName)
  },
  updated() {
    if (this.product.productName === '') {
        this.product.productName = store.getters.productName
        this.editWorkingHours = false
        this.editWorkingMinutes = false
    }    
  },
  beforeUnmount() {
    this.messageShow = 0
  },  
  components: {OptionButtons, DirectCostItem,ProductThumbnail}

}
</script>

<style lang="scss" scoped>
.modal-body {
  max-height: calc(100vh - 210px);
  overflow-y: auto;
}

.product-image-section {
  text-align: center;
  
  img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
  }
}

.card {
  border: none;
  border-radius: 8px;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 8px rgba(0,0,0,0.1) !important;
  }
}

.form-group label {
  font-size: 0.9rem;
  color: #495057;
}

.input-group {
  .form-control {
    border-right: 0;
    
    &:disabled {
      background-color: #f8f9fa;
    }
  }
  
  .input-group-append .btn {
    border-left: 0;
  }
}

.table {
  th {
    background-color: #f8f9fa;
    border-top: none;
  }
  
  td {
    vertical-align: middle;
  }
}

.btn-info {
  &:hover {
    background-color: darken(#17a2b8, 10%);
  }
}

// Responsive adjustments
@media (max-width: 768px) {
  .modal-body {
    padding: 1rem;
  }
  
  .card {
    margin-bottom: 1rem;
  }
  
  .btn {
    width: 100%;
    margin-bottom: 0.5rem;
  }
  
  .modal-footer {
    flex-direction: column-reverse;
    
    .btn {
      margin-bottom: 0.5rem;
    }
  }
}

// Animations
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
